// extracted by mini-css-extract-plugin
module.exports = {"component":"note_component_1ZJEJ","text":"note_text_1SGO5","headline":"note_headline_1BKh-","subtext":"note_subtext_110lI"};